import React from "react";
import { Card, Tabs } from "antd";
import UserManagement from "./UserManagement/UserManagement";
import RoleManagement from "./RoleManagement/RoleManagement";
import BreadcrumbList from "../../Shared/Components/Breadcrumb/Breadcrumb";
import './AdminMain.scss';
import UserPermissions from "./UserPermissions/UserPermissions";

const { TabPane } = Tabs;

export default function AdminMain(props) {

  const handleTabChange = (activeTab) => {
    localStorage.setItem('activeSettingsTab',activeTab);
  }
  const activeSettingsTab = JSON.parse(JSON.stringify(localStorage.getItem('activeSettingsTab')));
  return (
    <div className="admin-main">
      <Card
        style={{ width: "100%", height: "fit-content" }}
        bodyStyle={{ padding: "10px" }}
      >
        <BreadcrumbList active={[{ label: "Admin Dashboard", link: "" }]} />
      </Card>
      <Card bordered={false} style={{ margin:'10px' }} className="admin-body-card">
        <Tabs defaultActiveKey={activeSettingsTab !== null ? activeSettingsTab : 'userManagement'} className="admin-body-card" onChange={handleTabChange}>
          <TabPane tab="User Management" key="userManagement">
            <UserManagement />
          </TabPane>
          <TabPane tab="Department Configuration" key="departmentConfiguration">
            <RoleManagement />
          </TabPane>
          {/* <TabPane tab="User Permissions" key="userPermissions">
            <UserPermissions />
          </TabPane> */}
        </Tabs>
      </Card>
    </div>
  );
}
